module.exports = __webpack_public_path__ + "static/media/brand_1.png";